import { render, staticRenderFns } from "./DevMod.vue?vue&type=template&id=5df24e53&scoped=true"
import script from "./DevMod.vue?vue&type=script&lang=js"
export * from "./DevMod.vue?vue&type=script&lang=js"
import style0 from "./DevMod.vue?vue&type=style&index=0&id=5df24e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df24e53",
  null
  
)

export default component.exports